import { __assign } from "tslib";
import { findIndex, get, isNumber } from 'lodash-es';
import { isInAnnotationMode } from './annotation';
import { getOverlayByID } from './overlay';
import { getHotspotByID } from './hotspot';
import { isEmbedded } from './project';
import { isImageLoaded, isImageLoadable, isImageLoading, isImageError, isImageIdle, } from './imagePreloading';
import { isInHandoffMode } from './handoff';
import { NO_OF_SCREENS_TO_PRELOAD, NO_OF_SCREENS_TO_PRELOAD_WHEN_EMBEDDED, } from '../constants/screen';
export function getCurrentScreenProps(state) {
    var screen = getCurrentScreen(state);
    var isLoaded = isImageLoaded(state, screen.id);
    var isDownloadFailed = isImageError(state, screen.id);
    return __assign(__assign({ isVisible: true, isCurrent: true, isPlacingAnnotation: isInAnnotationMode(state), isLoaded: isLoaded,
        isDownloadFailed: isDownloadFailed, isScreenTransitionComplete: isTransitionComplete(state) }, screen), getCommonProps(state));
}
export function getPreviousScreenProps(state) {
    var transition = state.screen.transition;
    if (!transition || isTransitionComplete(state)) {
        // If there's no transition we don't need to show the previous
        // screen as it's just being directly replaced with no animation
        return {};
    }
    var screen = getPreviousScreen(state);
    var isLoaded = false;
    var isDownloadFailed = false;
    if (screen) {
        isLoaded = isImageLoaded(state, screen.id);
        isDownloadFailed = isImageError(state, screen.id);
    }
    var isTransitioning = !isTransitionComplete(state);
    return __assign(__assign({ isCurrent: false, isScreenTransitionComplete: !isTransitioning, isVisible: screen.id && isTransitioning, isLoaded: isLoaded,
        isDownloadFailed: isDownloadFailed }, screen), getCommonProps(state));
}
function getCommonProps(state) {
    return {
        size: state.screen.renderedDimensions,
        backgroundColor: state.project.config.screenBackgroundColour,
        transition: state.screen.transition,
        isTransitionReversed: state.screen.isTransitionReversed,
    };
}
export function getPendingAndLoadedScreenCounts(state) {
    var noOfLoadedImages = 0;
    var screenSequence = state.screen.screenSequence;
    screenSequence.forEach(function (screen) {
        /*
         * Loaded screen should be neither PRELOADING nor IDLE
         * Can't check for `isImageLoaded`, because that fails for images RELOADING,
         * which casuses player to rerender and breaks scroll (i.e. doesn't remember scroll position)
         */
        var isLoaded = !isImageLoading(state, screen.id) && !isImageIdle(state, screen.id);
        if (isLoaded) {
            noOfLoadedImages += 1;
        }
    });
    var noOfImagesToPreload = getNoOfImagesToPreloadBeforeShowingFirstScreen(state);
    var noOfPendingImages = Math.max(0, noOfImagesToPreload - noOfLoadedImages);
    return { noOfPendingImages: noOfPendingImages, noOfLoadedImages: noOfLoadedImages };
}
export function getPreviewScreenImgURL(state) {
    var screen = getCurrentScreen(state);
    return screen.img.url;
}
export function getCurrentScreen(state) {
    var isInCommentMode = state.comment.areVisible;
    var currentOverlayScreen = getCurrentOverlayScreen(state);
    if (currentOverlayScreen && (isInHandoffMode(state) || isInCommentMode)) {
        return currentOverlayScreen;
    }
    return state.screen.currentScreen || {};
}
export function getCurrentOverlayScreen(state) {
    var currentOverlayHotspotID = state.screen.currentOverlayHotspot.id;
    if (currentOverlayHotspotID) {
        var currentOverlayID = getHotspotByID(state, currentOverlayHotspotID);
        if (currentOverlayID) {
            return getOverlayByID(state, currentOverlayID.destinationScreenID);
        }
    }
    return null;
}
export function getPreviousScreen(state) {
    return state.screen.previousScreen || {};
}
export function getRenderedScreenDimensions(state) {
    return state.screen.renderedDimensions;
}
export function getScreen(state, isCurrentOrScreenID) {
    if (isNumber(isCurrentOrScreenID)) {
        return state.project.config.screenMap[isCurrentOrScreenID];
    }
    if (isCurrentOrScreenID) {
        return getCurrentScreen(state);
    }
    return getPreviousScreen(state);
}
export function getTopBackgroundColour(state, isCurrent) {
    return getColour(state, 'top', isCurrent);
}
export function getBottomBackgroundColour(state, isCurrent) {
    return getColour(state, 'bottom', isCurrent);
}
function getColour(state, prop, isCurrent) {
    if (!isCurrent) {
        return null;
    }
    return state.screen.currentScreen.colorSamples[prop];
}
export function isTransitionComplete(state) {
    var _a = state.screen.isTransitionComplete, previous = _a.previous, current = _a.current;
    return previous && current;
}
export function isGIFResetRequired(state) {
    return getCurrentScreen(state).img.url === state.screen.resetGIF;
}
export function areInitialScreensPreloaded(state) {
    var noOfPendingImages = getPendingAndLoadedScreenCounts(state).noOfPendingImages;
    return noOfPendingImages === 0;
}
export function getCurrentScreenIndex(state) {
    var currentScreen = getCurrentScreen(state);
    return findIndex(state.screenSequence, function (s) { return s.id === currentScreen.id; });
}
function getNoOfImagesToPreloadBeforeShowingFirstScreen(state) {
    if (isEmbedded(state)) {
        return NO_OF_SCREENS_TO_PRELOAD_WHEN_EMBEDDED;
    }
    var images = state.project.config.screens.filter(function (screen) {
        return isImageLoadable(screen);
    });
    return Math.min(NO_OF_SCREENS_TO_PRELOAD, images.length);
}
export function getSectionID(state) {
    return get(state, 'screen.sectionID');
}
